<script setup lang="ts">
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "./../home/repeat/Navbar.vue";
import { ref } from "vue";
const router = useRouter();
</script>

<template>
  <div class="company">
    <div class="main">
      <div class="kong">
        <Header></Header>
      </div>
      <div class="img_box">
        <div class="img_text">
          <div class="img_inner">
            <h2>{{ $t("system.about.company.inner_h") }}</h2>
            <div class="img_main">
              <div>{{ $t("system.about.company.main_dt") }}</div>
              <div>{{ $t("system.about.company.main_db") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="wrap_title">
          <div class="title_box">
            <div class="title">
              <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
              <text>></text>
              <a class="th">{{ $t("system.home.menu.companyIntroduction") }}</a>
            </div>
          </div>
        </div>
        <div class="con">
          <div class="con_box">
            <div class="box_inner">
              <div class="inner_l">
                <div class="left_text">
                  <class class="text_title">{{ $t("system.home.p_t") }}</class>
                  <div class="text_box">
                    <div style="line-height: 26px">
                      {{ $t("system.about.company.textBox_o") }}
                    </div>
                    <div style="line-height: 26px">
                      {{ $t("system.about.company.textBox_t") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="inner_r">
                <img src="./../../assets/imgs/squan.png" alt="" />
              </div>
            </div>
          </div>
          <div class="con_wrap">
            <div class="c_w_b">
              <div class="wrap_o">
                <div class="wrap_o_c">{{ $t("system.about.company.oba") }}</div>
                <div class="wrap_o_b">{{ $t("system.about.company.oca") }}</div>
                <div class="wrap_o_d">{{ $t("system.about.company.oda") }}</div>
              </div>
              <!-- 2 -->
              <div class="wrap_o">
                <div class="wrap_o_c">{{ $t("system.about.company.obb") }}</div>
                <div class="wrap_o_b">{{ $t("system.about.company.ocb") }}</div>
                <div class="wrap_o_d">{{ $t("system.about.company.odb") }}</div>
              </div>
              <!-- 3 -->
              <div class="wrap_o">
                <div class="wrap_o_c">{{ $t("system.about.company.obc") }}</div>
                <div class="wrap_o_b">{{ $t("system.about.company.occ") }}</div>
                <div class="wrap_o_d">{{ $t("system.about.company.odc") }}</div>
              </div>
              <!-- 4 -->
              <div class="wrap_o">
                <div class="wrap_o_c">{{ $t("system.about.company.obd") }}</div>
                <div class="wrap_o_b">{{ $t("system.about.company.ocd") }}</div>
                <div class="wrap_o_d">{{ $t("system.about.company.odd") }}</div>
              </div>
              <!-- 5 -->
              <div class="wrap_o">
                <div class="wrap_o_c">{{ $t("system.about.company.obe") }}</div>
                <div class="wrap_o_b">
                  {{ $t("system.about.company.oce") }}
                </div>
                <div class="wrap_o_d">{{ $t("system.about.company.ode") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.img_box {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../../public/36\(1\).jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}
.img_text {
  width: 1519px;
  height: 173px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  line-height: 1.25;
}
.img_inner {
  align-items: center;
  width: 1230px;
  padding: 0 15px;
  height: auto;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.img_main {
  align-items: center;
  width: 100%;
  height: 103px;
  font-size: 32px;
  line-height: 1.72;
  margin-top: 20px;
}
h2 {
  width: 100%;
  font-size: 46px;
  height: 50px;
  padding: 0;
  font-weight: bold;
  color: #20538c;
  margin: 0;
}
.wrap {
  width: 100%;
  height: auto;
}
.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  font-size: 14px;
  height: 26px;
}
.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
  box-sizing: border-box;
}
.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}
.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}
.con {
  width: 100%;
  height: auto;
  padding-bottom: 20px;
}
.con_box {
  width: 100%;
  height: 408px;
  padding-top: 0;
}
.box_inner {
  width: 1230px;
  height: 408px;
  padding: 0 15px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.inner_l {
  width: auto;
  display: flex;
  align-items: center;
  height: 100%;
}
.left_text {
  width: 100%;
  align-items: center;
  height: auto;
}
.inner_r {
  width: auto;
  height: 100%;
}
.inner_r img {
  border: none;
  display: inline-block;
  max-width: 100%;
  height: auto;
}
.text_title {
  width: 100%;
  height: auto;
  font-size: 24px;
  color: #00266e;
  font-weight: bold;
}
.text_box {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: 16px;
  margin-top: 20px;
  height: auto;
  max-width: 660px;
}
.con_wrap {
  padding: 60px 0;
  background-color: #f0f0f0;
  text-align: center;
  width: 100%;
}
.c_w_b {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%; // 修改为100%
  max-width: 1230px; // 添加最大宽度限制
  min-height: 500px;
  padding: 0 15px;
  margin: 0 auto;
}
.wrap_o {
  display: flex;
  flex-direction: column;
  justify-content: center; // 修改为center
  align-items: center; // 添加居中对齐
  width: 100%;
  text-align: center;
  margin-bottom: 50px;
}
.wrap_o_b {
  width: 100%;
  max-width: 1000px;
  font-size: 32px;
  color: #00266e;
  padding: 10px 0;
  font-weight: bold;
  margin: 0 auto;
  overflow-wrap: break-word; 
  line-height: 1.4; 
  min-height: 50px; 
}
.wrap_o_c {
  width: 100%;
  line-height: 26px;
  font-size: 24px;
  height: auto;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}
.wrap_o_d {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  font-size: 16px;
}
</style>
